import type { Template } from "@/types";

export const LA_07_H1_V6: Template[] = [
    {
        id: "la-07-h1v6-01",
        name: "LA 01 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 44, y: 61, width: 587, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 783, y: 35, width: 149, height: 227, rotation: 0, imageRotation: 0 },
            { id: "3", x: 940, y: 35, width: 149, height: 227, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1097, y: 35, width: 149, height: 227, rotation: 0, imageRotation: 0 },
            { id: "5", x: 783, y: 270, width: 149, height: 227, rotation: 0, imageRotation: 0 },
            { id: "6", x: 940, y: 270, width: 149, height: 227, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1097, y: 270, width: 149, height: 227, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-02",
        name: "LA 02 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 131, y: 55, width: 415, height: 241, rotation: 0, imageRotation: 0 },
            { id: "2", x: 790, y: 55, width: 286, height: 420, rotation: 0, imageRotation: 0 },
            { id: "3", x: 131, y: 303, width: 133, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 272, y: 303, width: 133, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 413, y: 303, width: 133, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1084, y: 55, width: 149, height: 206, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1084, y: 269, width: 149, height: 206, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-03",
        name: "LA 03 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 115, y: 55, width: 446, height: 268, rotation: 0, imageRotation: 0 },
            { id: "2", x: 115, y: 331, width: 106, height: 145, rotation: 0, imageRotation: 0 },
            { id: "3", x: 229, y: 331, width: 106, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 331, width: 105, height: 145, rotation: 0, imageRotation: 0 },
            { id: "5", x: 456, y: 331, width: 105, height: 145, rotation: 0, imageRotation: 0 },
            { id: "6", x: 763, y: 68, width: 248, height: 396, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 68, width: 248, height: 396, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-04",
        name: "LA 04 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 169, y: 55, width: 331, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 169, y: 258, width: 162, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 339, y: 258, width: 162, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 802, y: 55, width: 298, height: 420, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1108, y: 55, width: 102, height: 135, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1108, y: 198, width: 102, height: 134, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1108, y: 341, width: 102, height: 134, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-05",
        name: "LA 05 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 169, y: 55, width: 331, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 169, y: 258, width: 162, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 339, y: 258, width: 162, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 844, y: 55, width: 167, height: 207, rotation: 0, imageRotation: 0 },
            { id: "5", x: 844, y: 270, width: 167, height: 206, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1019, y: 55, width: 166, height: 207, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 270, width: 166, height: 206, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-06",
        name: "LA 06 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 74, y: 82, width: 529, height: 366, rotation: 0, imageRotation: 0 },
            { id: "2", x: 842, y: 39, width: 110, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 842, y: 193, width: 110, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 842, y: 347, width: 110, height: 145, rotation: 0, imageRotation: 0 },
            { id: "5", x: 960, y: 39, width: 226, height: 300, rotation: 0, imageRotation: 0 },
            { id: "6", x: 960, y: 347, width: 109, height: 145, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1077, y: 347, width: 109, height: 145, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-07",
        name: "LA 07 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 74, y: 82, width: 529, height: 366, rotation: 0, imageRotation: 0 },
            { id: "2", x: 842, y: 38, width: 110, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 842, y: 192, width: 227, height: 299, rotation: 0, imageRotation: 0 },
            { id: "4", x: 960, y: 38, width: 109, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1077, y: 38, width: 109, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1077, y: 192, width: 109, height: 146, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1077, y: 346, width: 109, height: 145, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-08",
        name: "LA 08 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 113, y: 77, width: 442, height: 249, rotation: 0, imageRotation: 0 },
            { id: "2", x: 113, y: 333, width: 82, height: 121, rotation: 0, imageRotation: 0 },
            { id: "3", x: 203, y: 333, width: 82, height: 121, rotation: 0, imageRotation: 0 },
            { id: "4", x: 293, y: 333, width: 82, height: 121, rotation: 0, imageRotation: 0 },
            { id: "5", x: 383, y: 333, width: 82, height: 121, rotation: 0, imageRotation: 0 },
            { id: "6", x: 473, y: 333, width: 82, height: 121, rotation: 0, imageRotation: 0 },
            { id: "7", x: 820, y: 0, width: 389, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-09",
        name: "LA 09 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 53, width: 262, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 53, width: 261, height: 427, rotation: 0, imageRotation: 0 },
            { id: "3", x: 539, y: 53, width: 126, height: 210, rotation: 0, imageRotation: 0 },
            { id: "4", x: 539, y: 271, width: 126, height: 209, rotation: 0, imageRotation: 0 },
            { id: "5", x: 673, y: 53, width: 545, height: 427, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1226, y: 53, width: 126, height: 209, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1226, y: 271, width: 126, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-10",
        name: "LA 10 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 53, width: 262, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 53, width: 261, height: 427, rotation: 0, imageRotation: 0 },
            { id: "3", x: 539, y: 53, width: 275, height: 210, rotation: 0, imageRotation: 0 },
            { id: "4", x: 539, y: 271, width: 134, height: 209, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 271, width: 133, height: 209, rotation: 0, imageRotation: 0 },
            { id: "6", x: 822, y: 53, width: 261, height: 427, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1091, y: 53, width: 261, height: 427, rotation: 0, imageRotation: 0 }
        ],
    }
];